<template>
	<div class="logistics">
		<div v-for="(item,index) in arrayExpress" :key="'logistics' + index">
			<div class="logistics-one">
				<div>物流编号：
					<span>{{item.expressNo}}</span>
				</div>
				<div>快递公司：
					<span>{{item.expressCompany }}</span>
				</div>
				<div>邮寄时间：
					<span>{{item.expressTime}}</span>
				</div>
			</div>

			<div class='nodata' v-if='item.logTracks == null'>
				<div class="weui-loadmore weui-loadmore_line">
					<div class="weui-loadmore__tips weui-loadmore__tips_in-line back_line">暂无数据</div>
				</div>
			</div>
		
		<div class="logistics-two" v-if="item.logTracks != null">
			<div class="logistics-two-content">
				<div class="xian">
				</div>

				<div v-for="(item,index) in item.logTracks" :key="'logisticstwo' +index">
					<div class="logistics-pone" v-if="index == 0">
						<div class="bigbg">
							<div class="smallbg">

							</div>
						</div>
						<div class="logistics-text">
							<p>{{item.acceptStation}}</p>
							<p class="logistics-text-time">{{item.acceptTime}}</p>
						</div>
					</div>


					<div class="logistics-pone" v-if="index > 0">
						<div class="gray">

						</div>
						<div class="logistics-text updated">
							<p>{{item.acceptStation}}</p>
							<p class="logistics-text-time">{{item.acceptTime}}</p>
						</div>
					</div>
				</div>


			</div>

		</div>
		</div>
	</div>
</template>

<script>
	let arrayExpress = [];
	export default {
		data() {
			return {
				arrayExpress: [],
			}
		},
		created() {
			let str = this.$route.query.logistics;
			let logistics = JSON.parse(str);
			console.log(logistics)
			this.getLogQuery(logistics)
		},
		methods: {
			getLogQuery(logistics) {
				// 'expressNo=' + expressNo + "&expressCompany=" + expressCompany + "&expressTime=" + expressTime;
				let params = {
					expressNo: logistics.expressNo,
					expressCompany: logistics.expressCompany,
					expressTime: logistics.expressTime
				}
				this.$server.logQuery(params).then(res => {
					if (res.result == 1) {
						let logTracks = res.logTracks;
						var obj = {
							'expressNo': logistics.expressNo,
							'expressCompany': logistics.expressCompany,
							'expressTime': logistics.expressTime,
							'logTracks': logTracks
						}
						arrayExpress.push(obj);
						this.arrayExpress = arrayExpress;
					}
				})
			}
		}
	}
</script>

<style>
	.nodata {
		margin-top: 20px;
	}

	.back_line {
		background-color: #efeff4;
	}

	.logistics-one {
		background: white;
		width: 100%;
		padding: 20px;
		margin-top: 5px;
		line-height: 30px;
		color: #666;
		font-size: 15px;
		box-sizing: border-box;
	}

	.logistics-one span {
		color: #333333;

	}

	.logistics-two {
		margin-top: 5px;
		padding: 20px;
		background: white;
		overflow: hidden;

	}

	.logistics-two-content {
		/*background: yellowgreen;*/
		position: relative;
		overflow: hidden;
	}

	.logistics-pone {
		/*background: yellow;*/
		display: inline-block;
		position: relative;
		width: 100%;
		margin-bottom: 10px;

	}

	.bigbg {
		width: 20px;
		height: 20px;
		background: #75D8E6;
		border-radius: 10px;
		/*overflow: hidden;
	    display: inline-block;
	    position: absolute;
	    top: 0;
	    left: 0;*/
		float: left;
		z-index: 10;
	}

	.smallbg {
		width: 12px;
		height: 12px;
		background: #01BAD4;
		border-radius: 6px;
		margin: 4px;
	}

	.gray {
		width: 12px;
		height: 12px;
		background: #CCCCCC;
		border-radius: 6px;
		margin: 4px;
		float: left;
	}

	.logistics-text {

		float: left;
		margin-left: 16px;
		line-height: 30px;
		width: 80%;
		padding-bottom: 10px;
		border-bottom: 1px solid #EEEEEE;
	}

	.updated {
		color: #999999;
	}

	/*.logistics-textp{
		margin-bottom: 10px;
		font-size: 15px;
		font-weight: 400;
		color: #333333;
	}*/
	p.logistics-text-time {
		color: #999999;
	}

	.xian {
		position: absolute;
		border-left: 2px solid #DDDDDD;
		height: 100%;
		z-index: 0;
		top: 10px;
		left: 9px;
	}
</style>
